import React, { FC, useEffect, useRef, useState } from 'react';
import styles from './ProductGallery.module.css';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import { useTranslation } from 'react-i18next';

export interface ProductGalleryProps {
    images: string[];
}

export const ProductGallery: FC<ProductGalleryProps> = ({ images }) => {
    const [active, setActive] = useState<number>(0);
    const [openLightbox, setOpenLightbox] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const { t } = useTranslation();

    const translations = {
        galleryAlt: (index: number) => t('product-detail-component.gallery.alt', { index: `${index}` }),
    };

    const slides = images.map((image) => ({
        src: image || '',
    }));

    const handleImageClick = (index: number) => {
        setCurrentImageIndex(index);
        setOpenLightbox(true);
    };

    const horizontalScrollContainerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const container = horizontalScrollContainerRef.current;

        const handleWheel = (e: WheelEvent) => {
            if (container && e.deltaY !== 0) {
                e.preventDefault();
                container.scrollLeft += e.deltaY;
            }
        };

        if (container) {
            container.addEventListener('wheel', handleWheel, { passive: false });
        }

        return () => {
            if (container) {
                container.removeEventListener('wheel', handleWheel);
            }
        };
    }, []);

    return (
        <div data-testid="product-gallery">
            {images[active] && (
                <img
                    src={images[active]}
                    className={`w-100 ${styles['active-image']}`}
                    onClick={() => handleImageClick(active)} 
                    alt={translations.galleryAlt(1)}
                    style={{ cursor: 'pointer' }}
                />
            )}
            <div ref={horizontalScrollContainerRef} className={`${styles['more-product-photos']} mb-5`}>
                {images.map((image, index) => (
                    <img
                        key={`image-${index}`}
                        src={image}
                        alt={translations.galleryAlt(index + 1)}
                        onClick={() => {
                            setActive(index); 
                            handleImageClick(index); 
                        }}
                        style={{ cursor: 'pointer' }}
                    />
                ))}
            </div>

            <Lightbox
                open={openLightbox}
                close={() => setOpenLightbox(false)}
                slides={slides}
                index={currentImageIndex}   
                toolbar={{
                    buttons: ['close'],
                }}
                controller={{
                    closeOnBackdropClick: true,
                }}
            />
        </div>
    );
};